// extracted by mini-css-extract-plugin
export var container = "_4o-0";
export var error = "_4o-9";
export var label = "_4o-5";
export var light = "_4o-6";
export var md = "_4o-3";
export var sm = "_4o-2";
export var thin = "_4o-8";
export var thinBold = "_4o-7";
export var vertical = "_4o-4";
export var xs = "_4o-1";